/** A white control over the map tiles (IcMapFilter's box): Border/default, a 0 1 2 shadow. */
export const MAP_CONTROL_CLASS =
  "border border-border-primary bg-white shadow-[0_1px_2px_rgba(0,0,0,0.05)]";
